import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiClose, mdiDelete } from "@mdi/js";
import { pushNotification } from "utils/notifications";
import {
  getListDanhSachDonDatHang,
  updateDataSearch,
} from "../../../../../actions/DanhSachDonDatHang";
import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
import { getUserLogin } from "utils/utils";
import DatHangApi from "../../../../../service/DatHang/DatHangApi";
import { getBranch } from "utils/utils";
export const ModalXoa = ({ CloseModal, item }) => {
  const dispatch = useDispatch();

  const init = {
    OrderDatHangID: item.OrderDatHangID,
    sUserName: getUserLogin().UserName,
    Note: "",
  };
  const [dataXoa, setDataXoa] = useState(init);

  useEffect(() => {
    document.addEventListener(
      "keydown",
      (e) => {
        escFunction(e);
      },
      false
    );
  }, []);
  useLayoutEffect(() => {
    document.removeEventListener(
      "keydown",
      (e) => {
        escFunction(e);
      },
      false
    );
  }, []);

  const escFunction = (event) => {
    if (event.key === "Escape") {
      CloseModal();
    }
  };
  const onChangeText = (field, e) => updateStateThongTin(field, e);
  const updateStateThongTin = (field, e) => {
    const thongtin = { ...dataXoa };
    const value = e.target.validity.valid ? e.target.value : thongtin[field];
    thongtin[field] = value;
    setDataXoa(thongtin);
  };

  const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);

  const [doubleClick, setDoubleClick] = useState(false);
  const onSubmit = () => {
    setDoubleClick(true);
    DatHangApi.xoaDonhang(
      dataXoa.OrderDatHangID,
      dataXoa.sUserName,
      dataXoa.Note
    ).then((response) => {
      if (response.status === 200) {
        CloseModal();
        pushNotification(
          "Xóa đơn bán hàng thành công",
          "success",
          "TOP_RIGHT",
          2000
        );
        dispatch(getListDanhSachDonDatHang(dataSearch));
      } else {
        setDoubleClick(false);
        pushNotification(response.data, "error", "TOP_RIGHT", 2000);
      }
    });
  };
  return (
    <>
      <div className="popup ">
        <div class="popup_inner " style={{ maxWidth: "500px", marginTop: "75px" }}>
          <div class="modal-content form-modal-new">
            <div class="modal-header">
              <h4
                class="modal-title"
                id="myLargeModalLabel"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <div class="bgIconTitle">
                  <Icon path={mdiDelete} title="" color="#fff" size={1.5} />
                </div>
                Xoá đơn hàng mã: {item.OrderCode}
              </h4>
              <button
                type="button"
                class="close"
                onClick={CloseModal}
                aria-label="Close"
              >
                <Icon path={mdiClose} title="In" size={1.5} color="#ccc" />
              </button>
            </div>
            <div class="modal-body text-left-main">
              <span style={{ color: "red" }}>
                Bạn có chắc chắn muốn xóa đơn đặt hàng đã chọn?
              </span>
            </div>
            <div class="modal-footer">
              <div class="footer-search-main">
                <button
                  type="submit"
                  class="text-button-search mr-2"
                  onClick={CloseModal}
                >
                  Huỷ bỏ
                </button>
                <button
                  class="button-Add-NoIcon bg-blue-main"
                  onClick={onSubmit}
                  disabled={doubleClick}
                >
                  Thực hiện
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
